module.exports = __webpack_public_path__ + "img/articles5.77803da3.jpg";